import { Grid, GridItem } from '@rsa-digital/evo-shared-components/components/Grid';
import React from 'react';
import { trackLinkClick } from 'helpers/eventTracking';
import { RichTextStyle } from './styles';
import { RichTextData } from '../types';

const RichTextBlock: React.FC<RichTextData> = ({ rich_text }) => (
  <Grid className="richText">
    <GridItem>
      <RichTextStyle
        id={rich_text.html_id}
        html={rich_text.html}
        data-cy="RichText"
        onLinkClick={trackLinkClick}
        focusable
      />
    </GridItem>
  </Grid>
);

export default React.memo(RichTextBlock);
